"use strict";
var prop = require("prop");
var par = require("par");

module.exports = createTracker;

/**
 * Creates a new tracker instance for a given dispatcher.
 * The point of trackers is to group a bunch of  events together and allow for
 * easily removing listeners registered in the group by event name,
 * or just all listeners at once.
 * @param {Dispatcher} dispatcher The dispatcher instance to bind to
 */
function createTracker(dispatcher) {
	// Contains items with {event, fn}.
	// Represents the events and listeners in this tracker.
	var tracking = [];

	/**
	 * Tracker instance that gets generated
	 * @type {Tracker}
	 */
	var tracker = {
		on: on,
		off: off
	};

	return tracker;

	/**Add an event listener and start tracking it.
	 * @param  {String}   event Event to listen on the dispatcher
	 * @param  {Function} fn    The listener function to bind
	 * @return {Tracker}        Returns self for chaining pruposes
	 */
	function on(event, fn) {
		tracking.push({
			event: event,
			fn: fn
		});
		dispatcher.on(event, fn);
		return tracker;
	}

	/**Removes all event listeners that match a given event name, or all listeners.
	 * @param  {String} event The event to stop listening on. If opmitted, all listeners are removed
	 * @return {Tracker}        Returns self for chaining pruposes
	 */
	function off(event) {
		if (!event) {
			tracking.map(prop("event")).forEach(off);
			return tracker;
		}
		tracking = tracking.filter(par(remove_if_matches, event));
	}

	/** Used for removing a listener if it matches an event name
	 */
	function remove_if_matches(event, tracker) {
		if (tracker.event !== event) return true;
		dispatcher.removeListener(event, tracker.fn);
		return false;
	}
}
